import { render, staticRenderFns } from "./QRCode.vue?vue&type=template&id=1327f8f4&scoped=true&"
import script from "./QRCode.vue?vue&type=script&lang=js&"
export * from "./QRCode.vue?vue&type=script&lang=js&"
import style0 from "./QRCode.vue?vue&type=style&index=0&id=1327f8f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1327f8f4",
  null
  
)

export default component.exports